import "./index.scss";

export const Divider = () => <div className="divider" />;
